import React, { memo } from "react";
import { NavLink } from "react-router-dom";
import { GameImage } from "./GameImage.jsx";

function GameComponent({
    igra,
    brands,
    categories,
    fromNative,
    fromNativeGameName,
    extraClass,
    showJackpot,
    routePrefix,
    goLazyImage,
    isVerticalImage,
    gameNameClass,
    from,
    PageName,
    GamePosition,
    PositionType,
    ComponentName,
    ComponentPosition,
    IsIcon,
    TabName,
    TabPosition,
    SliderName,
    SliderPosition,
    SearchValue,
    FilterValue
}) {
    const game = igra;
    const brand = brands?.[game?.bID];

    // Rive thumbnail rendering is controlled by the value received from CasinoAdmin
    const isRive = Boolean(game?.ir);

    // The "o" game property indicates that the game is under maintenance.
    const maintenanceClass = game?.p?.includes("o") ? "maintenance " : "";

    // Sends game and category information to Google Tag Manager when a game is opened
    const createGoogleTagEvent = () => {
        if (!categories || !game?.kt) {
            return;
        }
        // Convert the game's category IDs into readable category names for analytics
        const kategorijeArray = Object.keys(game.kt)
            .map(key =>
                categories.find(category => category.id == key)
            )
            .filter(Boolean)
            .map(category => category.name);

        casino.utils.createGoogleTagManagerEvent({
            event: "game_click",
            game_name: game.n,
            game_provider: brand?.name || "",
            game_type: kategorijeArray.join(),
            jackpot: game.jp ? "yes" : "no",
            jackpot_amount: game.jp || 0,
            gameId: game.id
        });
    };

    // Normalize the game name once and reuse it in native and browser URLs
    const normalizedGameName = casino.utils.normalizeString(game.n);

    // Shared game image markup used by both native and browser links.
    const gameImage = (
        <GameImage
            igra={game}
            brands={brands}
            showJackpot={showJackpot}
            routePrefix={routePrefix}
            goLazyImage={goLazyImage}
            categories={categories}
            isRive={isRive}
            isVerticalImage={isVerticalImage}
        />
    );

    // Shared jackpot indicator and game title
    const gameInfo = (
        <div className="relative">
            {showJackpot && game.jp && (
                <div className="game-jackpot" />
            )}

            <span className={`game-name ${gameNameClass || ""}`}>
                {game.n}
            </span>
        </div>
    );

    // Native application links
    if (fromNative) {
        const link = fromNativeGameName
            ? `supersport://casino/games/${game.s}`
            : `https://mcasino.supersport.hr/game/${brand.nameNormalizirano}/${normalizedGameName}`;

        return (
            <a
                href={link}
                onClick={createGoogleTagEvent}
                id={`game-${game.id}`}
                className={`game-item ${maintenanceClass}${extraClass || ""}`}
            >
                {gameImage}
                {gameInfo}
            </a>
        );
    }

    // Build the React Router path for browser navigation
    const pathname = `${routePrefix || ""}/`.replace("//", "/") + `game/${brand.nameNormalizirano}/${normalizedGameName}`;

    return (
        <NavLink
            onClick={createGoogleTagEvent}
            to={{
                pathname,
                query: {
                    game: normalizedGameName,
                    from: from || "",
                    PageName,
                    GamePosition,
                    PositionType,
                    ComponentName,
                    ComponentPosition,
                    IsIcon,
                    TabName,
                    TabPosition,
                    SliderName,
                    SliderPosition,
                    SearchValue,
                    FilterValue
                }
            }}
            id={`game-${game.id}`}
            className={`game-item ${maintenanceClass}${extraClass || ""}`}
        >
            {gameImage}
            {gameInfo}
        </NavLink>
    );
}

// Skip rerendering while the values that affect this card remain unchanged.
function arePropsEqual(previousProps, nextProps) {
    return (
        previousProps.SearchValue === nextProps.SearchValue &&
        previousProps.FilterValue === nextProps.FilterValue &&
        previousProps.igra.id === nextProps.igra.id &&
        previousProps.igra.jr === nextProps.igra.jr
    );
}

// Preserve the original shouldComponentUpdate behavior
export const Game = memo(GameComponent, arePropsEqual);